
<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
  <g fill="#FFF" fill-rule="evenodd">
    <rect width="32" height="32" opacity=".3" rx="2"/>
    <path fill-rule="nonzero" d="M23.721 17.23v5.813h-3.37V17.62c0-1.362-.487-2.292-1.707-2.292-.93 0-1.485.626-1.728 1.233-.09.216-.112.518-.112.821v5.66h-3.37s.045-9.184 0-10.135h3.37v1.436l-.023.033h.022v-.033c.448-.69 1.248-1.675 3.038-1.675 2.218 0 3.88 1.45 3.88 4.563zM9.907 8.02C8.754 8.02 8 8.777 8 9.771c0 .973.732 1.753 1.863 1.753h.022c1.176 0 1.907-.78 1.907-1.753-.023-.994-.731-1.75-1.885-1.75zM8.2 23.043h3.37V12.907H8.2v10.136z"/>
  </g>
</svg>
